/* eslint-disable no-param-reassign */
/* eslint-disable import/no-unresolved */
import React, { useState, useEffect } from 'react'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import MobileStepper from '@material-ui/core/MobileStepper'
import Button from '@material-ui/core/Button'
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft'
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight'
import YouTubeIcon from '@material-ui/icons/YouTube'
import IconButton from '@material-ui/core/IconButton'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import Skeleton from '@material-ui/lab/Skeleton'
import Tooltip from '@material-ui/core/Tooltip'
import ListItemAvatar from '@material-ui/core/ListItemAvatar'
import Avatar from '@material-ui/core/Avatar'
import Divider from '@material-ui/core/Divider'
import { Box } from '@material-ui/core'
import { useStyles } from './styles'
// import useNearScreen from '../../utils/hooks/useNearScreen'

const VideoCommentsList = ({ comments }) => {
  const classes = useStyles()
  const limit = 30

  const [activeStep, setActiveStep] = useState(0)
  const [interval, setInterval] = useState({ inf: 0, sup: limit })
  let reducer = []
  const handleNext = () => {
    setActiveStep(prevActiveStep => prevActiveStep + 1)
  }

  const handleBack = () => {
    setActiveStep(prevActiveStep => prevActiveStep - 1)
  }

  useEffect(() => {
    setInterval({
      inf: activeStep * limit,
      sup: activeStep * limit + limit,
    })
  }, [activeStep])

  reducer =
    Array.isArray(comments.comments) &&
    comments?.comments
      .map(comment => comment.items.map(item => item?.snippet))
      .reduce((reducedSentences, sentences) => {
        reducedSentences = reducedSentences.concat(sentences)
        return reducedSentences
      }, [])

  return (
    <>
      {!comments.loading ? (
        <List id='lista' dense component='div' key='key'>
          {reducer.length > 0 ? (
            reducer.slice(interval.inf, interval.sup).map(item => (
              <div key={item?.topLevelComment.etag}>
                <ListItem alignItems='flex-start' >
                    <ListItemAvatar>
                    <Avatar alt='Remy Sharp' src={item?.topLevelComment.snippet.authorProfileImageUrl} />
                  </ListItemAvatar>
                  <Box className={classes.containerInfoComments}>
                    <ListItemText
                    primary={item?.topLevelComment.snippet.textOriginal}
                  />
                  <ListItem component='span' className={classes.infoComments}>
                    <div>
                      {`Autor: ${item?.topLevelComment.snippet.authorDisplayName}`}
                      <br />
                      {`Fecha ${item?.topLevelComment.snippet.publishedAt}`}
                      <br />
                      {`Likes del comentario: ${item?.topLevelComment.snippet.likeCount}`}
                    </div>
                  </ListItem>
                  </Box>
                  <ListItemSecondaryAction>
                    <Tooltip title='Ver video' aria-label='video'>
                      <a target='blank' href={`https://www.youtube.com/watch?v=${item.videoId}`}>
                        <IconButton edge='end' aria-label='youTubeGoo'>
                          <YouTubeIcon style={{ color: '#ff0000' }} />
                        </IconButton>
                      </a>
                    </Tooltip>
                  </ListItemSecondaryAction>
                </ListItem>
                <Divider />
              </div>
            ))
          ) : (
            <div className={classes.center}>
              <div>Este video no tiene comentarios asociados a este análisis, prueba con otro análisis</div>
            </div>
          )}
        </List>
      ) : (
        <div>
          <Skeleton />
          <Skeleton animation={false} />
          <Skeleton animation='wave' />
        </div>
      )}
      {reducer.length > 0 && (
        <MobileStepper
          // ref={element}
          variant='dots'
          steps={Math.ceil(reducer?.length / limit)}
          position='static'
          activeStep={activeStep}
          className={classes.root}
          nextButton={(
            <Button size='small' onClick={handleNext} disabled={activeStep === Math.ceil(reducer?.length / limit) - 1}>
              Next
              <KeyboardArrowRight />
            </Button>
          )}
          backButton={(
            <Button size='small' onClick={handleBack} disabled={activeStep === Math.ceil(reducer?.length / limit) + 1}>
              <KeyboardArrowLeft />
              Back
            </Button>
          )}
        />
      )}
    </>
  )
}

export default VideoCommentsList
